export type ServiceStatusMetadata = {
  serviceId: string
  serviceName: string
  environmentName: string
  commitSha?: string | null
  branch?: string | null
  commitSource?: string | null
  buildTimeUtc?: string | null
}

let metadataPromise: Promise<ServiceStatusMetadata | null> | null = null

export function getCurrentServiceStatusMetadata() {
  if (metadataPromise) {
    return metadataPromise
  }

  metadataPromise = fetch('/service-status.json', { cache: 'no-store' })
    .then(async (response) => {
      if (!response.ok) {
        return null
      }

      return await response.json() as ServiceStatusMetadata
    })
    .catch(() => null)

  return metadataPromise
}
